module.exports = __webpack_public_path__ + "img/cqyx.f3f1978c.png";